/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Count of the referral's active task workflow items by status
 * @export
 * @interface TaskWorkflowProgress
 */
export interface TaskWorkflowProgress {
    /**
     * 
     */
    incomplete: number;
    /**
     * 
     */
    pending: number;
    /**
     * 
     */
    passed: number;
    /**
     * 
     */
    failed: number;
}

/**
 * Check if a given object implements the TaskWorkflowProgress interface.
 */
export function instanceOfTaskWorkflowProgress(value: object): value is TaskWorkflowProgress {
    if (!('incomplete' in value) || value['incomplete'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    if (!('passed' in value) || value['passed'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    return true;
}

export function TaskWorkflowProgressFromJSON(json: any): TaskWorkflowProgress {
    return TaskWorkflowProgressFromJSONTyped(json, false);
}

export function TaskWorkflowProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowProgress {
    if (json == null) {
        return json;
    }
    return {
        
        'incomplete': json['incomplete'],
        'pending': json['pending'],
        'passed': json['passed'],
        'failed': json['failed'],
    };
}

export function TaskWorkflowProgressToJSON(json: any): TaskWorkflowProgress {
    return TaskWorkflowProgressToJSONTyped(json, false);
}

export function TaskWorkflowProgressToJSONTyped(value?: TaskWorkflowProgress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'incomplete': value['incomplete'],
        'pending': value['pending'],
        'passed': value['passed'],
        'failed': value['failed'],
    };
}

